<div class="dx-card p-3 responsive-paddings">
  <ng-content></ng-content>
</div>